import template from "./template.twig";

const { Component, Mixin } = Shopware;

Component.register("neti-incomplete-order-reminder-customer-tab", {
    template,

    props: {
        customer: {
            type: Object,
            required: true,
        },
    },

    inject: ["repositoryFactory"],

    mixins: [
        Mixin.getByName("listing"),
    ],

    data() {
        return {
            currency: null,
            cartEntries: [],
            isLoading: false,
            sortBy: "createdAt",
            sortDirection: "DESC",
            naturalSorting: true,
            cartModalOpen: false,
            detailCart: null,
            additionalFilters: []
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create("product");
        },

        currencyRepository() {
            return this.repositoryFactory.create("currency");
        },

        columns() {
            return this.getColumns();
        },

        cartItemColumns() {
            return this.getModalColumns();
        },

        currencyFilter() {
            return Shopware.Filter.getByName("currency");
        },

        dateFilter() {
            return Shopware.Filter.getByName("date");
        }
    },

    created() {
        this.getList();
    },

    methods: {
        getList() {
            this.isLoading = true;
            this.loadIncompleteCarts().then(data => {
                this.cartEntries = data.cart;
                this.length      = data.cart.length;
                this.total       = data.total;
                this.isLoading   = false;
            }, error => {
                console.error(error);

                this.isLoading = false;
            });
        },

        onFilterChanged(filters) {
            this.additionalFilters = filters;
            this.getList();
        },

        loadIncompleteCarts() {
            let httpClient = Shopware.Application.getContainer("init").httpClient;
            let headers    = {
                Accept: "application/vnd.api+json",
                Authorization: `Bearer ${ Shopware.Context.api.authToken.access }`,
                "Content-Type": "application/json"
            };

            let orderParams = {
                "sortBy": this.sortBy,
                "sortDirection": this.sortDirection,
                "page": this.page,
                "limit": this.limit,
                "filters": this.additionalFilters,
                "customerId": this.customer.id
            };

            return new Promise((resolve, reject) => {
                httpClient.post("_action/neti-incomplete-order-reminder/carts", orderParams, { headers })
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch(reject);
            });
        },

        onColumnSort(column) {
            this.onSortColumn(column);
        },

        onUpdateRecords(result) {
            this.total = result.total;
            this.data  = result;
        },

        onPageChange(opts) {
            this.page  = opts.page;
            this.limit = opts.limit;
            if (this.disableRouteParams) {
                this.getList();
                return;
            }
            this.updateRoute({
                page: this.page,
            });
        },

        async showCartModal(cart) {
            this.isLoading = true;
            await this.currencyRepository.get(cart.currencyId, Shopware.Context.api).then(currency => {
                this.currency = currency;
            });

            let httpClient = Shopware.Application.getContainer("init").httpClient;
            let headers    = {
                Accept: "application/vnd.api+json",
                Authorization: `Bearer ${ Shopware.Context.api.authToken.access }`,
                "Content-Type": "application/json"
            };

            let cartParams = {
                "token": cart.token,
                "salesChannelId": cart.salesChannelId,
            };

            httpClient.post("_action/neti-incomplete-order-reminder/cartDetail", cartParams, { headers })
                .then(({ data }) => {
                    if (data.success) {
                        this.detailCart = data.cart;
                    }

                    this.cartModalOpen = cart.token;
                    this.isLoading     = false;
                });
        },

        onCloseCartModal() {
            this.detailCart    = null;
            this.cartModalOpen = false;
        },

        getColumns() {
            return [
                {
                    property: "totalPrice",
                    dataIndex: "totalPrice",
                    label: this.$t("neti-incomplete-order-reminder.customer.columnTotalPrice"),
                    primary: true
                },
                {
                    property: "mailed",
                    dataIndex: "mailed",
                    label: this.$t("neti-incomplete-order-reminder.customer.columnReminded"),
                    primary: true
                },
                {
                    property: "createdAt",
                    dataIndex: "createdAt",
                    label: this.$t("neti-incomplete-order-reminder.customer.columnCreatedAt"),
                    primary: true
                },
            ];
        },

        getModalColumns() {
            return [
                {
                    property: "quantity",
                    dataIndex: "quantity",
                    label: "sw-order.detailBase.columnQuantity",
                    allowResize: false,
                    align: "right",
                    inlineEdit: true,
                    width: "90px",
                }, {
                    property: "label",
                    dataIndex: "label",
                    label: "sw-order.detailBase.columnProductName",
                    allowResize: false,
                    primary: true,
                    inlineEdit: true,
                    multiLine: true,
                },
                {
                    property: "price.unitPrice",
                    dataIndex: "price.unitPrice",
                    label: "sw-order.detailBase.columnPriceGross",
                    allowResize: false,
                    align: "right",
                    inlineEdit: true,
                    width: "120px",
                },
                {
                    property: "price.totalPrice",
                    dataIndex: "price.totalPrice",
                    label: "sw-order.detailBase.columnTotalPriceGross",
                    allowResize: false,
                    align: "right",
                    width: "120px",
                }
            ];
        }
    }
});
